/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Max_Steps_IncreaseInputs */



/**
* | output |
* | --- |
* | "Increase the action limit" |
*
* @param {Agent_Builder_Max_Steps_IncreaseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_max_steps_increase = /** @type {((inputs?: Agent_Builder_Max_Steps_IncreaseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Max_Steps_IncreaseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktionslimit erhöhen")
	return /** @type {LocalizedString} */ ("Increase the action limit")
});